/*
 * This files needs to be loaded at first because it generates the angular.js module
 * which is required for all the other components in this module
 */
angular.module('mx.auth.acs', ['mx.auth']);